import React, {Component} from 'react';
import DetailView from "../views/DetailView";
import {withError, withCourseSearchApi, FormUtility, withRouter, withStyleguide, HandleLoading} from "cw-styleguide-react";
import i18n from "../../../i18n";
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";

class DetailController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course:{},
      venuesCount: 0,
      loaded:null,
      formErrors:[],
      messages:[]
    };
  }

  componentDidMount() {

    this.props.courseSearchApiGetCourse(this.props.params.course.split('-').pop(), i18n.language, (response) => {

      switch(response.status) {
        case 204:
          this.setState({
            messages: new Set([{'type':'warning-alert',"message": this.props.t('styleguide:messages.error204')}]),
            loaded:false
          })
          break
        default:

          if (response.data.courseGroup.subContractedProvider && response.data.courseGroup.subContractedProvider.atlasAccountId) {
          response.data.provider = response.data.courseGroup.subContractedProvider;
          } else {
         response.data.provider = response.data.courseGroup.mainProvider;
          }

          let venuesCount = 0;

          response.data.sessions.map((session, sessionIndex) => {

            if ("venues" in session && session['venues'].length) {
              venuesCount++;
            }
          });

          this.setState({
            course:response.data,
            venuesCount: venuesCount,
            loaded:true
          });


         this.props.styleguide.setLanguageUrl(route('detail', {'course':FormUtility.slugify(response.data.title) + '-' + response.data.id},this.props.i18n.language === 'cy' ? 'en' : 'cy'));
          break;
      }

    }, (error) => {

      let errors = FormUtility.processServerErrors(error, i18n);

      if (error.response.status == 404) {
        this.setState({
          loaded: error.response.status
        })
      } else {
        this.setState({
          messages: errors.messages,
          loaded: false
        })
      }


    });

  }

  render() {
    return <HandleLoading loading={{loaded:this.state.loaded}} messages={this.state.messages} container={true}>
           <DetailView {...this.props} {...this.state}  slug={this.props.match.params.course}/>
    </HandleLoading>;
  }
}

export default withStyleguide(withCourseSearchApi(process.env)(withTranslation('local')(withRouter(withError(DetailController)))));
